import { render, staticRenderFns } from "./IconTotemSuccess.vue?vue&type=template&id=88fb63e8&scoped=true&"
import script from "./IconTotemSuccess.vue?vue&type=script&lang=js&"
export * from "./IconTotemSuccess.vue?vue&type=script&lang=js&"
import style0 from "./IconTotemSuccess.vue?vue&type=style&index=0&id=88fb63e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88fb63e8",
  null
  
)

export default component.exports